import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Collapse, ProgressBar, Dialog, Button, MenuItem } from '@blueprintjs/core';
import { MultiSelect } from '@blueprintjs/select';
import { Paper } from '@material-ui/core';
import EnhancedSingleSelect from '../../../common/EnhancedSingleSelect';


import KwicTable from './KwicTable';
import MetaData from './MetaData';
import UnfoldedView from './UnfoldedView';
import { corpusConcordsShape } from './shapes';
import Tree from './Tree'
import Play from './Play'
import Meta from './Meta'
import Tokens from './Tokens'
import Context from './Context'
import { openConlluPopup } from '../../../utils'
import { openPagePopup } from '../../../utils'
import Cookies from 'js-cookie';
import { FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME } from '../../../auth/constants';

import './concordance.css';
// export interface ICollapseExampleState {
//   isOpenMetadata?: boolean;
// };

// Todo : try https://www.npmjs.com/package/@material-table/core, to prevent sort cancellation when rerendering KwickTable
// cf. https://github.com/mbrn/material-table/issues/2252
class Concordance extends React.PureComponent {

  state = {
   // kwicClass:"flex-two-panels",
   // isOpenMetadata:true,
    isKwic: true,
    selectedSentId: "",
    concordDetail: null,  // Indicate if metadata panel is on
    waitingForConcordDetail : false,
    permalink:"",
    displayInfo: "", // 5 values accepted "meta","tree","tokens","audio","context"
    isOpenModal:false,
    wavUrl:"",
    filteringAttr:null,
    filteringVals: [],
    filteringValues: []
  }

  toggleModal = () => {
    this.setState(prevState => ({ isOpenModal: !prevState.isOpenModal}));
  }

  // run the query to get all the details and metadata linked to a given concord entry
  fetchConcordDetails(lang,docMeta,aligned_language,concordData,displayInfo) {
    const data = {
      sent_id: concordData.sentId,
      collection: docMeta[concordData.docId].collection,
      lang: lang,
      aligned_language:aligned_language
    };

    //console.log("displayInfo",displayInfo);

    const endpoint = '/get_result_meta.ajax.php';
    if (this.props.isOpenMetadata || displayInfo==="") { //  
      // this will trigger rerendering (and cancelling the sort option)
      this.setState({waitingForConcordDetail:true, selectedSentId:concordData.sentId, selectedRow:concordData });
    }
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify(data),
      })
      .then((res) => {
        if (res.status !== 200) {
          console.log(`Issue reaching ${endpoint}`);
          return ;
        }
        res.json().then((concordDetail) => {
          // console.log("concord reçu");
          // console.log(concordDetail);
          if (displayInfo==="") {
            this.setState({ 
              selectedSentId:concordData.sentId,
              concordDetail:concordDetail, 
              permalink:concordDetail.permalink, // re rendering will cancel the sort
              waitingForConcordDetail:false, 
            });
          } else {
            this.setState({ 
              selectedSentId:concordData.sentId,
              concordDetail:concordDetail, 
              //permalink:concordDetail.permalink, // to prevent rerender of the table when clicking on button
              waitingForConcordDetail:false, 
              displayInfo:displayInfo ,
              isOpenModal:true
            });
          }
        })
      })
      .catch(() => {
        console.log(`Network error when trying to fetch ${endpoint}`);
      })
      return ;
  }
  displayTree =()=>{
    this.setState({ 
      displayInfo: 'tree' ,
      isOpenModal: true
    });
  }
  displayPlay =()=>{
    this.setState({ 
      displayInfo: 'audio' ,
      isOpenModal: true
    });
  }

  // load the metadata details in the state
  // first arg is the rowData, second is a boolean that indicates if the function is executed when componentDidMount
  getConcordDetail = (concordData,displayInfo) => {
    const { docMeta, lang, aligned_language } = this.props;

    if (concordData.sentId && concordData.sentId === this.state.selectedSentId) {
      if (displayInfo!=="") {
        this.setState({ 
          displayInfo: displayInfo ,
          isOpenModal: true
        });
      }
      //console.log("id="+concordData.tableData.id);// do nothing
      return;
    }

    this.fetchConcordDetails(lang,docMeta,aligned_language,concordData,displayInfo);

  };

  copyToClipboard = (concordData) => {
    var additionalMeta="";
    if (this.props.docMeta[concordData.docId]) {
      if (this.props.docMeta[concordData.docId]["author"]) {
        additionalMeta+=this.props.docMeta[concordData.docId]["author"]+" ";
      }
      if (this.props.docMeta[concordData.docId]["year"]) {
        additionalMeta+="("+this.props.docMeta[concordData.docId]["year"]+") ";
      }
      if (this.props.docMeta[concordData.docId]["title"]) {
        additionalMeta+=this.props.docMeta[concordData.docId]["title"];
      }            
    }

    var content=concordData.left+" "+
            concordData.node+" "+
            concordData.right+" ["+
            concordData.sentId+", "+
            additionalMeta+"]";
    content=content.replace(/\[\[\[|#\w+\]\]\]/g,"");
    console.log("Paste",content);
    if (navigator.clipboard) {
      this.unsecuredCopyToClipboard(content);
      //navigator.clipboard.writeText(content);
    } else {
      this.unsecuredCopyToClipboard(content);
    }
  }


// hacking the https control for clipboard access cf. https://stackoverflow.com/questions/72237719/not-being-able-to-copy-url-to-clipboard-without-adding-the-protocol-https
unsecuredCopyToClipboard =(text) => {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.focus({preventScroll:true});
  textArea.select();
  try {
    document.execCommand('copy');
  } catch (err) {
    console.error('Unable to copy to clipboard', err);
  }
  document.body.removeChild(textArea);
}


  onChangeFilteringAttr= (e) => {
    e.preventDefault();
    const {value} = e.target;
    if (this.props.attr_val_doc[value]) {
      this.setState({filteringAttr:value,filteringVals:Object.keys(this.props.attr_val_doc[value]).sort(),filteringValues:[]});
    }
  };

  filterElements = (query, filterElement) => {
    const filterItem = filterElement;
    const filterItemUpper = filterItem.toUpperCase();
    const queryUpper = query.toUpperCase();
    return filterItemUpper.includes(queryUpper);
  }

  addSelectedFilter = (filterItem) => {
    const filteringValues=this.state.filteringValues;
    if (filteringValues.indexOf(filterItem)===-1) {
      filteringValues.push(filterItem);
      this.setState({filteringValues:[...filteringValues] });
    }
  }

  removeSelectedFilter = (filterItem) => {
    const filteringValues=this.state.filteringValues;
    filteringValues.splice(filteringValues.indexOf(filterItem),1);
    this.setState({filteringValues:[...filteringValues] });
  }


  render() {
    const { concordDetail, selectedSentId, displayInfo } = this.state;
    const { isKwic, kwicClass, attr_val_doc, concords, t } = this.props;
    var filteredConcords=[];
    var modalTitle;
    var modalWidth="auto"
    var m=concordDetail && concordDetail.permalink ? concordDetail.permalink.match(/collection=(.*)&sentId=(.*)_(\d+)$/):null;
    var numSent;
    var fileId;
    var collection;
    var intervalSentNum;
    const attrs=Object.keys(attr_val_doc);
    const isUserFrontLoggedIn = !!(Cookies.get(FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME));

    if (m) {
      collection=m[1];
      fileId=m[2];
      numSent=m[3];
      const firstSent=parseInt(numSent)-10>0? parseInt(numSent)-10 : 0;
      const lastSent=parseInt(numSent)+10;
      intervalSentNum= firstSent.toString()+"#"+lastSent.toString();
      //console.log(collection,fileId,numSent,intervalSentNum);
    }

    if (displayInfo==='tree') {
      modalTitle=t('syntaxicTree');
      if (concordDetail.svg.match(/viewBox="[\d.]+ [\d.]+ (\d+)[\d.]+ [\d.]+"/i)) {
        modalWidth=(parseInt(RegExp.$1)+60).toString()+"px"; // + 60 for the padding
        //console.log("Width",modalWidth)
      }
    } 
    if (displayInfo==='audio') {
      modalTitle=t('play');
    } 
    if (displayInfo==='tokens') {
      modalTitle=t('tokens');
    } 
    if (displayInfo==='meta') {
      modalTitle=t('metadata');
    } 
    if (displayInfo==='context') {
      modalTitle=t('context');
    } 
    
    // applying filters
    if (this.state.filteringAttr && this.state.filteringValues.length>0) {
      filteredConcords=concords.filter( (concordLine)=>{
        const docId=concordLine.docId;
        for (var val of this.state.filteringValues) {
          if (attr_val_doc[this.state.filteringAttr][val][docId]) {
            return true;
          }
        }
        return false;
      });
    }

    const kwicTable= <KwicTable
                        concords={filteredConcords.length>0 ? filteredConcords: this.props.concords}
                        selectedSentId={this.state.selectedSentId}
                        permalink={this.state.permalink}
                        isOpenMetadata={this.props.isOpenMetadata}
                        getConcordDetail={this.getConcordDetail}
                        copyToClipboard={this.copyToClipboard}
                        openConlluPopup={openConlluPopup}
                        lang={this.props.lang}
                        aligned_language={this.props.aligned_language}
                        docMeta={this.props.docMeta}
                        concordSpan={this.props.concordSpan}
                        collections={this.props.collections['collection']}
                        performSearch={this.props.performSearch}
                        queryNumber={this.props.queryNumber}
                      />;
    const unfoldedView= <UnfoldedView
                          concords={filteredConcords.length>0 ? filteredConcords: concords}
                          getConcordDetail={this.getConcordDetail}
                          permalink={this.state.permalink}
                          performSearch={this.props.performSearch}
                          docMeta={this.props.docMeta}
                        />;                      

    return (
      <div>
        { this.props.displayName &&
          <div style={{color:"green",marginBottom:"20px"}}>{t('subCorpusName')} : {this.props.name}</div>
        } 

        <div className='flex'>
          <EnhancedSingleSelect
            options={attrs}
            //value={attrs}
            hasDefault={true}
            hasSelectableDefault={true}
            label={t('filteringAttr')}
            name={"filteringAttr"}
            onChange={this.onChangeFilteringAttr}
            popoverProps={{ minimal: true }}
          />
          
          <MultiSelect
              label={t('filteringVals')}
              items={this.state.filteringVals}
              itemRenderer={
                (item, { handleClick, modifiers }) => (
                  <MenuItem
                    key={"menuItems"+item}
                    active={modifiers.active}
                    text={item}
                    icon={this.state.filteringValues.includes(item) ? 'tick' : 'blank'}
                    onClick={handleClick}
                    shouldDismissPopover={false}
                  />
                )
              }
              itemPredicate={(query, filterElement) => this.filterElements(query, filterElement)}
              onItemSelect={(filterElement) => this.addSelectedFilter(filterElement)}
              onRemove={(filterElement) => this.removeSelectedFilter(filterElement) }
              selectedItems={this.state.filteringValues}
              tagInputProps={{
                interactive: true,
                onRemove: (filterElement) => this.removeSelectedFilter(filterElement),
              }}
              // tagRenderer takes as input what selectedItems gives
              tagRenderer={filterLabel => filterLabel}
              noResults={<MenuItem disabled={true} text={t('noResult')} />}
              placeholder={t('filteringVal')}
          />
        </div> 

        <div className="flex flex-between">
          <div id="kwic" style={{width:'100%'}} className={kwicClass}>
            <div className="padding-1-rem" style={{width:'100%'}} >
              {isKwic ? kwicTable : unfoldedView }
            </div>
          </div>

          <Collapse isOpen={this.props.isOpenMetadata}>
            <div className="flex-two-panels">
              <div className="padding-1-rem">
                {this.state.waitingForConcordDetail &&
                  <Paper className="padding-1-rem">
                    <div>ID : {selectedSentId} </div>
                    <br/>
                    <ProgressBar />
                  </Paper>
                }              
                {concordDetail &&
                  <MetaData 
                      sent_id={selectedSentId} 
                      concordDetail={concordDetail} 
                      getConcordDetail={this.getConcordDetail}
                      displayTree={this.displayTree}
                      displayPlay={this.displayPlay}
                      pasteQuery= {this.props.pasteQuery}
                      lang= {this.props.lang}
                  />
                }

              </div>
            </div>
          </Collapse>

          <Dialog
                scroll={'body'}
                isOpen={this.state.isOpenModal}
                onClose={this.toggleModal}
                title={modalTitle}
                style={{'width':modalWidth}}
          >
                { this.state.displayInfo==="meta" &&
                  <Meta sentId={selectedSentId} metadata={ this.state.concordDetail.metadata } />
                }
                { this.state.displayInfo==="context" &&
                  <>
                  <Context 
                    concordDetail={ this.state.concordDetail } 
                    fileId= {fileId}
                    collection= {collection}
                    language= {this.props.lang}
                    intervalSentNum= {intervalSentNum}
                    pasteQuery= {this.props.pasteQuery}
                    parentDialogToggleModal= {this.toggleModal}
                  />
                  { isUserFrontLoggedIn && 
                    <Button className='readingButton' onClick={ 
                      (e)=>{ 
                        e.stopPropagation();
                        openPagePopup ( this.props.lang,
                                        collection,
                                        fileId,
                                        numSent,
                                        this.props.aligned_language);
                      }}>
                      {t('reading')}
                    </Button>
                  }
                  </>

                }
                { this.state.displayInfo==="tokens" &&
                  <Tokens tokens={ this.state.concordDetail.tokens }/>
                }
                { this.state.displayInfo==="tree" &&
                  <Tree svg={this.state.concordDetail.svg} />
                } 
                { this.state.displayInfo==="audio" &&
                  <Play text={ this.state.concordDetail.sentence } wavUrl={ this.state.concordDetail.metadata.wavLink }/>
                } 
                    
          </Dialog>
        
        </div>
      
      </div>
    );
  }
}

Concordance.propTypes = {
  name: PropTypes.string,
  displayName : PropTypes.bool,
  collections: PropTypes.object,
  concords: corpusConcordsShape,
  docMeta: PropTypes.object,
  lang: PropTypes.string,
  aligned_language: PropTypes.string,
  kwicClass: PropTypes.string,
  isOpenMetadata: PropTypes.bool,
  isKwic: PropTypes.bool,
  concordSpan: PropTypes.number,
  attr_val_doc: PropTypes.object,
  pasteQuery: PropTypes.func,
  performSearch:PropTypes.func,
  queryNumber:PropTypes.number
};

export default withTranslation()(Concordance);
